import type { FaireProductEntity } from "../../entity_types/product";

export const p_xxgtqj585r: FaireProductEntity = {
  token: "p_xxgtqj585r",
  type: "product",
  name: "Men's Soft Athleisure Lounge Jogger Pant",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/a01787f596ce63037eba4079ff075b8562b88a380ce6cc11e1b974d33aa9d9ff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d56e304dbbcdb7f298b93bea76471ac029ccf797c4cadc95122e2603a17bc1ec.jpeg",
    "https://cdn.faire.com/fastly/13270ea679c975bc8fcc180f838066e5d67980c5cb2497c2fa29a73dd89781c0.jpeg",
    "https://cdn.faire.com/fastly/cbc5f46b83b15e9f752bb2832cbffd201b5acbd29e3054afe386b444fed10ad7.jpeg",
    "https://cdn.faire.com/fastly/815a434735ad4be2524bb640030776d9629a681f8921186151a009ed2e4713e1.jpeg",
    "https://cdn.faire.com/fastly/061584877e864ff901086893014c407815883b11ec63e9dcb2506d1cfa6ec084.jpeg",
    "https://cdn.faire.com/fastly/7ebd93b02679488de5a667f5ddd4bb4b4e30cc393c305f6060470d83ae7216d5.jpeg",
    "https://cdn.faire.com/fastly/eb519750262fe1bfc059d1b20206673e5c7c6e62314f1e5687df7f81a584d53e.jpeg",
    "https://cdn.faire.com/fastly/23b24725e8b4850d7fc0951d981103f973f3f7c5028d54c5fcf6398b42c00efb.jpeg",
    "https://cdn.faire.com/fastly/e5a38ac3b7d9dd7fd8680efaea7924c252c6a7b667fa4e85d43b8a4ab104304b.jpeg",
    "https://cdn.faire.com/fastly/00fdcf34f829fab17068bab52c1e81097a0f3fcab05a6273d7dc90fba152cade.jpeg",
    "https://cdn.faire.com/fastly/293a68f92e0df62cc5bb411476c86d069e8de120756292839619693151ec8cce.jpeg",
    "https://cdn.faire.com/fastly/07b422952e654d5a42faa7a79b518a18514b3229047cda7149e4c4838d5682dd.jpeg",
    "https://cdn.faire.com/fastly/a779e9acbb3c6a2988bd83246d1171e717d7192ba7424d25d991560e34a05611.jpeg",
    "https://cdn.faire.com/fastly/d59c0688f4c8a865450e2c37d94e750941c7be3ebc4b1111a0a98734270bb54a.jpeg",
    "https://cdn.faire.com/fastly/a71bc0b9268485ea26e7d1b4d7463c5874dc247b3d0dc4c15a8852aa883e94c2.png"
  ],
  priceDollars: 50,
  description: "Designed for the man who prefers pieces that last over fleeting trends, the Take 10 Men’s DreamTech Jogger strikes the perfect balance between contemporary cool and enduring design. Featuring a drawstring waist for an adjustable fit, these joggers ensure comfort is never compromised, whether you're running errands or enjoying a relaxed day at home.\n\nThe DreamTech fabric is cool to the touch and buttery against the skin for incomparable comfort. Critical to its practical design is the thoughtfully placed pockets, with one in the back and two in the front so you have ample space for smaller essentials.\n\n**𝐏𝐚𝐢𝐫𝐬 𝐖𝐞𝐥𝐥 𝐖𝐢𝐭𝐡**\n• Take 10 Men’s DreamTech ¼ Zip\n• Take 10 Men’s DreamTech Hoodie\n\n**𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬**\n• Jogger pant with side pockets\n• 29” inseam\n• Logo patch at pocket hem\n\n**𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞**\n• Easy care, colorfast and machine washable\n• Softies DreamTech fabric is 81% rayon, 14% nylon, 5% spandex",
  tags: [],
  msrpDollars: 99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:11.544Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
